import IconButton from '@material-ui/core/IconButton'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableContainer from '@material-ui/core/TableContainer'
import TableRow from '@material-ui/core/TableRow'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getSorting, stableSort } from '../../../../../util/TableUtils'
import { renderRoute, useQueryParams } from '../../../../../util/utils'
import EnhancedTableHead from '../../../../components/TableHead'
import {
  fetchServiceCategory,
  remove,
} from '../../../../service-category/ServiceCategoryActions'
import { StyledTableCellBody } from '../../../../../components/hooks/BaseTableComponents'
import { Box, Grid, Typography } from '@material-ui/core'
import colors from '../../../../../assets/colors'
import Pagination from '../../../../../components/hooks/BasePagination'
import { useHistory, useLocation } from 'react-router-dom'
import styles from '../../../../../resources/theme/global'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import classNames from 'classnames'

function createData(id, name, status, color, cashback_conversion) {
  return { id, name, status, color, cashback_conversion }
}

const headCells = [
  {
    id: 'indicator',
    numeric: true,
    disablePadding: false,
    label: '',
  },
  {
    id: 'os_number',
    numeric: true,
    disablePadding: false,
    label: 'Nº OS',
  },
  {
    id: 'operation',
    numeric: true,
    disablePadding: false,
    label: 'Operação',
  },
  {
    id: 'date',
    numeric: true,
    disablePadding: false,
    label: 'Data',
  },
  {
    id: 'points',
    numeric: true,
    disablePadding: false,
    label: 'Pontos',
    align: 'center',
  },
]

const useStyles = makeStyles(theme => ({
  link: {
    padding: '4px 12px',
    borderRadius: '.6em',
    textDecoration: 'none',
    backgroundColor: colors.bgInfo,
    color: colors.info,
    border: '1px solid',
    borderColor: colors.info,
    transition: 'all .4s ease-in-out',
    '&:hover': {
      color: colors.info,
      opacity: 0.7,
    },
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  centerCost: {
    height: '26px',
    width: '2px',
    borderRadius: '5px',
  },
  points: {
    borderRadius: '5px',
    width: '82px',
    height: '19px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#FFFF',
    fontSize: '12px',
    textAlign: 'center',
    lineHeight: '12px',
    padding: '4px 0',
    background: colors.graylight,
  },
  positiveBg: {
    background: colors.sucess,
  },
  negativeBg: {
    background: colors.error,
  },
  returnedBg: {
    background: colors.info,
  },
  positiveColor: {
    color: colors.sucess,
  },
  negativeColor: {
    color: colors.error,
  },
  returnedColor: {
    color: colors.info,
  },
}))

const List = props => {
  const { classes } = props

  const permissions = useSelector(state => state.auth.permissions)
  const items = useSelector(state => state.cashbackExtract.details)
  const meta = useSelector(state => state.cashbackExtract.meta)

  const styles = useStyles()

  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  const filters = useQueryParams(location?.search)

  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('value')
  const [selected, setSelected] = useState([])

  const [open, setOpen] = useState(false)

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === 'desc'
    setOrder(isDesc ? 'asc' : 'desc')
    setOrderBy(property)
  }

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelecteds = rows.map(n => n.name)
      setSelected(newSelecteds)
      return
    }
    setSelected([])
  }

  const handleChangeRowsPerPage = event => {
    const data = { ...filters, rows: event.target.value, page: 1 }
    handleSubmit(data)
  }

  const handleSubmit = data => {
    const searchParams = new URLSearchParams(data || filters)
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const onMovePage = (event, newPage) => {
    const data = { ...filters, page: newPage }
    handleSubmit(data)
  }

  return (
    <>
      <TableContainer style={{ height: 'calc(100vh - 300px)' }}>
        <Table
          className={classes?.table}
          aria-labelledby="Tabela de Categorias de Serviços"
        >
          <EnhancedTableHead
            classes={classes}
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={items.length}
            headCells={headCells}
            renderFirstTH={false}
          />
          <TableBody>
            {stableSort(items, getSorting(order, orderBy)).map(row => {
              return (
                <TableRow hover tabIndex={-1} key={row.id}>
                  <StyledTableCellBody
                    style={{
                      width: '5px',
                    }}
                  >
                    <Box
                      className={classNames({
                        [styles.centerCost]: true,
                        [styles.negativeBg]: row?.type == 2,
                        [styles.positiveBg]: row?.type == 1,
                        [styles.returnedBg]: row?.type == 3,
                      })}
                    />
                  </StyledTableCellBody>
                  <StyledTableCellBody
                    component={Link}
                    to={`/attendance/${row?.service_id}/edit?value=1${location.search}`}
                  >
                    {row?.service_id_laundry_client}
                  </StyledTableCellBody>

                  <StyledTableCellBody>
                    {row?.type == 1 && 'Cashback Recebido'}
                    {row?.type == 2 && 'Cashback Retirado'}
                    {row?.type == 3 && 'Cashback Estornado'}
                  </StyledTableCellBody>

                  <StyledTableCellBody>{row?.date}</StyledTableCellBody>

                  <StyledTableCellBody align="center">
                    <Box
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Box
                        className={classNames({
                          [styles.points]: true,
                          [styles.negativeBg]: row?.type == 2,
                          [styles.positiveBg]: row?.type == 1,
                          [styles.returnedBg]: row?.type == 3,
                        })}
                      >
                        {row?.points}
                      </Box>
                    </Box>
                  </StyledTableCellBody>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

export default withStyles(styles)(List)
